import {
  numberRegex,
  specialCharacterRegex,
  uppercaseRegex,
} from '../constants/constant';

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const isValidPassword = (password: string) => {
  const hasMinLength = password.length >= 8;
  const hasUppercase = uppercaseRegex.test(password);
  const hasNumber = numberRegex.test(password);
  const hasSpecialChar = specialCharacterRegex.test(password);
  return hasMinLength && hasUppercase && hasNumber && hasSpecialChar;
};
